module.exports = __webpack_public_path__ + "img/cert-csee.7d27d743.png";